var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('api-loader',{attrs:{"method":"get","url":"v1/farms"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var farms = ref.result;
return [(farms)?_c('b-card',[_c('ul',_vm._l((farms),function(farm){return _c('li',{key:farm.id},[_c('router-link',{attrs:{"to":{name: 'grazing/farm/by-id', params: {id: farm.id}}}},[_vm._v("\n          "+_vm._s(farm.name)+"\n        ")])],1)}),0)]):_vm._e()]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55270fd6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/grazing/views/FarmsView.vue
// module id = null
// module chunks = 